import { difficultyToColourClass, ratingToDifficulty } from './utils';
import type { FixtureCellData } from './constants';

type DoubleFixtureCellProps = {
  fixtureOne: FixtureCellData;
  fixtureTwo: FixtureCellData;
};

const MODERATE_DIFFICULTY = 5;
const FULL_LIKELIHOOD = 1;

type HalfProps = {
  fixture: FixtureCellData;
  position: 'top' | 'bottom';
};

const Half = ({ fixture, position }: HalfProps) => {
  const venueLabel = fixture.venue === 'home' ? '(H)' : '(A)';
  const difficulty =
    fixture.inferences?.difficulty.overall ?? MODERATE_DIFFICULTY;
  const toPlay = fixture.inferences?.probabilities.toPlay ?? FULL_LIKELIHOOD;
  const colourClass = difficultyToColourClass(ratingToDifficulty(difficulty));
  const isDoubtful = toPlay !== FULL_LIKELIHOOD;
  const roundedClass = position === 'top' ? 'rounded-t-md' : 'rounded-b-md';

  return (
    <div
      className={`relative flex h-1/2 w-full items-center justify-center px-1 py-0.5 text-[10px] leading-tight text-neutral-800 ${colourClass} ${roundedClass}`}
    >
      {isDoubtful && (
        <div
          className={`bg-diagonal-stripes pointer-events-none absolute inset-0 opacity-50 ${roundedClass}`}
        />
      )}
      <span className="relative whitespace-nowrap">
        {fixture.opponent.shortName} {venueLabel}
      </span>
    </div>
  );
};

export const DoubleFixtureCell = ({
  fixtureOne,
  fixtureTwo
}: DoubleFixtureCellProps) => (
  <div className="flex h-full w-full flex-col">
    <Half fixture={fixtureOne} position="top" />
    <Half fixture={fixtureTwo} position="bottom" />
  </div>
);
